import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] py-8 px-5 text-center border-t border-[#1a1a1a]" data-id="element-103">
      <p className="text-xs text-[#555] mb-2" data-id="element-104">
        © 2026 El Protocolo Blackout · Todos los derechos reservados
      </p>

      <p className="text-xs text-[#555] mb-3 space-x-2" data-id="element-105">
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-106">
          Términos y Condiciones
        </a>
        <span data-id="element-107">·</span>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-108">
          Política de Privacidad
        </a>
        <span data-id="element-109">·</span>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-110">
          Contacto
        </a>
      </p>

      <p className="text-[11px] text-[#333] max-w-[600px] mx-auto mt-4" data-id="element-111">
        Este producto es de carácter educativo e informativo. Los resultados
        pueden variar según cada persona y contexto.
      </p>
    </footer>;
}